import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { AppContext } from '../../../context/app';
import { ThemeType } from '../../../context/types';
import { useAddParamsAndNavigate } from '../../../hooks/useAddParamsAndNavigate';
import { isLatLng } from '../../../utils/typeGuards';
import CurrentLocationButton from '../currentLocationButton/CurrentLocationButton';
import Icon from '../icon/Icon';
import { IconType } from '../icon/types';
import Spinner from '../spinner/Spinner';
import styles from './currentLocation.module.scss';

const CurrentLocation: React.FC = () => {
  const { t } = useTranslation('common');
  const {
    navStartingPlace,
    mapLoading,
    setMapLoading,
    setIsUsingCurrentLocation,
  } = useContext(AppContext);

  const addParamsAndNavigate = useAddParamsAndNavigate();

  const [errorCurrentLocation, setErrorCurrentLocation] = useState<
    string | null
  >(null);
  const [currentLocationLoading, setCurrentLocationLoading] =
    useState<boolean>(false);

  const handleSelectCurrentLocation = () => {
    if (!navigator.geolocation) {
      setErrorCurrentLocation('Geolocation is not supported by your browser');
    } else {
      setMapLoading(true);
      setCurrentLocationLoading(true);
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const currentLocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };

          addParamsAndNavigate([
            {
              name: 'startingid',
              value: `${currentLocation.lat},${currentLocation.lng}`,
            },
          ]);
          setIsUsingCurrentLocation(true);

          setMapLoading(false);
          setCurrentLocationLoading(false);
        },
        (error) => {
          setErrorCurrentLocation(error.message);
          setMapLoading(false);
        },
        { enableHighAccuracy: true, maximumAge: Infinity },
      );
    }
  };

  return (
    <div className={styles.location}>
      {mapLoading && currentLocationLoading && !isLatLng(navStartingPlace) && (
        <>
          <div className={styles.hr}></div>
          <div className={styles.centerLoading}>
            <Spinner iconSize={40} theme={ThemeType.PRIMARY} />
            <p className={styles.label}>{t('labels.loadingLocation')}</p>
          </div>
          <div className={styles.hr}></div>
        </>
      )}
      {!mapLoading && !navStartingPlace && (
        <>
          <div className={styles.hr}></div>
          <CurrentLocationButton
            onClick={handleSelectCurrentLocation}
            disabled={!!errorCurrentLocation}
          />
          {errorCurrentLocation && (
            <div className={styles.error}>
              <Icon icon={IconType.LOCATION_OPEN} size={20} />
              {t('campusNavigation.errors.currentLocation')}
            </div>
          )}
          <div className={styles.hr}></div>
        </>
      )}
    </div>
  );
};

export default CurrentLocation;
